<template>
  <ol class="progress">
    <li v-for="(step, index) in steps" :key="index" :class="stepClass(step, index)">
      {{step.name}}
    </li>
  </ol>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    steps: Array,
    active: Number
  },
  methods: {
    stepClass: function (step, index) {
      let className = ''
      if (index < this.active) {
        className += 'is-complete '
      }
      if (index === this.active) {
        className += 'is-active '
      }
      if (index === this.steps.length - 1) {
        className += 'progress__last'
      }
      return className
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Progress.vue